export default __webpack_public_path__ + "static/caseStudy1-us-f2f37f17fc55382c8c07cbedf8bdad3b.webp";